import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

export type TableDensity = "compact" | "comfortable";

interface UIContextValue {
  /** Global default table row density. */
  density: TableDensity;
  setDensity: (density: TableDensity) => void;
}

const UIContext = createContext<UIContextValue | null>(null);

export function UIProvider({ children }: { children: ReactNode }) {
  const [density, setDensity] = useState<TableDensity>("compact");

  const value = useMemo<UIContextValue>(() => ({ density, setDensity }), [density]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI(): UIContextValue {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within UIProvider");
  return ctx;
}